module.exports = __webpack_public_path__ + "img/mt16.08a3e094.jpg";